/* eslint-disable no-unused-vars */
/* global G, PLATFORM, VARIANT */
import { asyncPipeSpread, asyncPipeSpreadIf, bulk } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { hide } from 'lib/sequence/component/state/hidden'
import settings from '@tenant/settings'

const { staticActions } = settings

const bulkHide = bulk(hide)

/**
 * Hides the `Information` menu block if there are no {@link staticActions} defined in tenant's
 * {@link settings}.
 *
 * @param {Gaia.AppModule.Spec} module the current module
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const displayInformationOptions = module => async (children, ...args) => {
  const { information, informationLabel } = children

  if (!staticActions?.length) {
    bulkHide(information, informationLabel)
  }

  return [children, ...args]
}

/**
 * Hides the `Storybook` and `Performance Test` development action if app is
 * running in production mode
 *
 * @param {Gaia.AppModule.Spec} module the current module
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const displayDeveloperOptions = module => async (children, ...args) => {
  const { development, developmentLabel } = children

  if (VARIANT !== 'development') {
    bulkHide(development, developmentLabel)
  }

  return args
}

/**
 * User Action Menu
 *
 * @param {Gaia.AppModule.Spec} module the current module
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  asyncPipeSpreadIf(() => PLATFORM === 'mobile')(
    displayInformationOptions(module),
    displayDeveloperOptions(module),
  ),
)(find(component), ...args)
